export default __webpack_public_path__ + "static/media/unique16.df56098b.PNG";